import { dispatchEvent } from '../Dispatcher';

function getErrorProperties(err) {
  return {
    errorString: err?.toString(),
    errors: err?.errors,
    traceId: err?.response?.headers['x-trace-id'],
  };
}

function getResourceProperties(resource) {
  return {
    selfLink: resource.link('self')?.url(),
    resourceType: resource.type(),
  };
}

function logEvent(eventName, eventProperties) {
  dispatchEvent({
    type: 'logEvent',
    properties: {
      eventName,
      eventProperties: {
        url: window.location.href,
        pathname: window.location.pathname,
        ...eventProperties,
      },
    },
  });
}

function logEventSuccess(eventName, eventProperties) {
  return logEvent(`${eventName} [SUCCESS]`, eventProperties);
}

function logEventFailure(eventName, eventProperties) {
  return logEvent(`${eventName} [FAILED]`, eventProperties);
}

function logEventFailureWithError(eventName, err, eventProperties) {
  return logEventFailure(eventName, {
    ...getErrorProperties(err),
    ...eventProperties,
  });
}

function logPageView(pageName, eventProperties) {
  dispatchEvent({
    type: 'page',
    properties: {
      eventName: pageName,
      eventProperties: {
        url: window.location.href,
        pathname: window.location.pathname,
        ...eventProperties,
      },
    },
  });
}

// ================================
// Resource
// ================================
function logResourceEvent(eventName, resource, eventProperties) {
  return logEvent(eventName, {
    ...getResourceProperties(resource),
    ...eventProperties,
  });
}

function logResourceEventSuccess(eventName, resource, eventProperties) {
  return logEventSuccess(eventName, {
    ...getResourceProperties(resource),
    ...eventProperties,
  });
}

function logResourceEventFailure(eventName, resource, eventProperties) {
  return logEventFailure(eventName, {
    ...getResourceProperties(resource),
    ...eventProperties,
  });
}

function logResourceEventFailureWithError(eventName, resource, err, eventProperties) {
  return logResourceEventFailure(eventName, resource, {
    ...getErrorProperties(err),
    ...eventProperties,
  });
}

export default {
  // Generic
  logEvent,
  logEventSuccess,
  logEventFailure,
  logEventFailureWithError,
  logPageView,
  // Resource
  logResourceEvent,
  logResourceEventSuccess,
  logResourceEventFailure,
  logResourceEventFailureWithError,
};
